import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Col, Row, Select } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import { toast } from 'react-toastify'
import { RoleIDMapping } from '../../hooks/ModulePermissionsMap'
const { Option } = Select

const BrokerForm = props => {
  const { form, UnderWriterID, InsurerID, recordID, onSuccess, modalVisible } =
    props

  const { getFieldDecorator } = form
  const [loading, setLoading] = useState(false)
  const [underwriterList, setUnderwriterList] = useState([])
  const [formattedUnderwriterList, setformattedUnderwriterList] = useState([])
  const [insurerList, setInsurerList] = useState([])
  const [recordId, setRecordId] = useState(0)
  const [loggedInUserID, setLoggedInUserID] = useState(null)

  useEffect(() => {
    fetchUnderwriters()
    fetchInsurers()
    if (UnderWriterID && InsurerID) {
      form.setFieldsValue({
        underWriterId: UnderWriterID,
        insurerIds: InsurerID,
      })
      setRecordId(recordID)
    } else if (InsurerID) {
      form.setFieldsValue({
        insurerIds: InsurerID,
      })
    } else {
      form.resetFields()
    }
  }, [UnderWriterID, modalVisible, InsurerID])

  const fetchInsurers = async () => {
    try {
      const insurers = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`,
        'GET',
      )

      setInsurerList(insurers?.data || [])
    } catch (err) {
      console.error('Error fetching insurers:', err)
    }
  }

  const fetchUnderwriters = async () => {
    try {
      const underwriters = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/underwriter-juniorunderwriter-cliammanager`,
        'GET',
      )
      const roleMap = {
        [RoleIDMapping('Underwriter')]: 'Underwriter',
        [RoleIDMapping('JuniorUnderwriter')]: 'Junior Underwriter',
        [RoleIDMapping('ClaimManager')]: 'Claim Manager',
      }
      const formattedData = (underwriters?.data || []).map(user => ({
        ...user,
        name: `${user.name} (${roleMap[user.roleId] || 'Unknown'})`,
        value: user.id,
      }))
      console.log(formattedData)
      setUnderwriterList(underwriters?.data || [])
      setformattedUnderwriterList(formattedData)
    } catch (err) {
      console.error('Error fetching underwriters:', err)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)

      try {
        const selectedInsurer = insurerList.find(
          ins => ins.id === values.insurerIds,
        )
        const selectedUnderwriter = underwriterList.find(
          u => u.id === values.underWriterId,
        )

        if (!selectedInsurer || !selectedUnderwriter) {
          toast.error('Invalid Insurer or UnderWriter selected')
          setLoading(false)
          return
        }

        const payload = {
          AssignorId: selectedInsurer?.id,
          AssignorName: selectedInsurer?.name,
          childDto: [
            {
              AssigneeId: selectedUnderwriter?.id,
              AssigneeName: selectedUnderwriter?.name,
            },
          ],
          id: recordId,
        }

        const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/AssignedSubordinates`

        const res = await apiRequest(url, 'POST', payload)
        if (res.success) {
          if (res.data?.success) {
            toast.success(
              UnderWriterID ? 'UnderWriter Updated!' : 'UnderWriter Assigned!',
            )
            onSuccess()
          } else {
            toast.error(res.data.message || 'Something went wrong')
          }
        } else {
          const msg = res.error?.toLowerCase?.() || ''
          toast.error(res.error || 'Something went wrong')
        }
      } catch (err) {
        console.error('Submit error:', err)
        toast.error('Request failed, try again.')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select Insurer">
                {getFieldDecorator('insurerIds', {
                  rules: [
                    { required: true, message: 'Please select an insurer' },
                  ],
                })(
                  <Select placeholder="Select Insurer">
                    {insurerList?.map(ins => (
                      <Option key={ins?.id} value={ins?.id}>
                        {ins?.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select UnderWriter">
                {getFieldDecorator('underWriterId', {
                  rules: [
                    { required: true, message: 'Please select an underwriter' },
                  ],
                })(
                  <Select placeholder="Select UnderWriter">
                    {formattedUnderwriterList?.map(u => (
                      <Option key={u.id} value={u.id}>
                        {u.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              {UnderWriterID ? 'Update' : 'Assign'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(BrokerForm)
